export default __webpack_public_path__ + "static/media/2.3cfa15a2.jpg";